<template>
    <div>
        <Button class="btn-back" @click="back()">返回</Button>
        <div class="search-box btn3">
            <div class="input-item">
                <span class="label">产品code/名称</span>
                <Input class="value" v-model="searchObj.productCodeOrName" placeholder="请输入" clearable />
            </div>

            <div class="input-item">
                <span class="label">保险公司</span>
                <Select v-model="searchObj.companyCode" clearable filterable transfer>
                    <Option :value="item.code" v-for="(item, index) in productCompany" :key="index">{{ item.name }}</Option>
                </Select>
            </div>
            <div class="btn-item">
                <Button type="primary" @click="search">查询</Button>
                <Button type="primary" ghost @click="reset">重置</Button>
            </div>
        </div>

        <div class="btn-item">
            <Button type="primary" @click="$refs.addProduct.open()">新增产品</Button>
            <Button :disabled="selectIds.length == 0" @click="del">批量删除</Button>
        </div>
        <div class="all-select">
            <Checkbox v-model="checkboxIsAll" @on-change="selectCheckboxIsAll">全部产品</Checkbox>
            <span
                >已选择<span class="select-num">{{ selectIds.length }}</span
                >项，共<span class="select-num">{{ total }}</span
                >款产品</span
            >
        </div>
        <loading :isShow="$root.$children[0].isShowLoading" />
        <div class="table-box setTable">
            <Table ref="selection" :columns="columns" :data="productList" @on-selection-change="selectRow">
                <template slot-scope="{ row }" slot="action">
                    <a class="disabled" v-if="status == 2 || status == 3 || disabled == '1'">删除</a>
                    <a @click="submitDelete(row)" v-else>删除</a>
                </template>
            </Table>
        </div>

        <div class="pageBox">
            <Page
                :total="total"
                :current="searchObj.pageNo"
                :page-size="searchObj.pageSize"
                show-total
                @on-change="pageChange"
                style="text-align: center"
            />
        </div>

        <add-product ref="addProduct" :initProductList="initProductList" :covenantId="covenantId"></add-product>
    </div>
</template>

<script>
import addProduct from './addProduct';
import { common } from '@/api/mixins';
export default {
    mixins: [common],
    name: 'signProduct',
    props: ['covenantId', 'status'],
    components: {
        addProduct
    },
    data() {
        return {
            disabled: null,
            checkboxIsAll: false,
            total: 0,
            searchObj: {
                pageNo: 1,
                pageSize: 10
            },
            list: [],
            productList: [],
            selectIds: [],
            productCompany:[],
            columns: [
                {
                    type: 'selection',
                    width: 50,
                    align: 'center'
                },
                {
                    title: '序号',
                    align: 'center',
                    width: 100,
                    type: 'index'
                },
                {
                    title: '产品code',
                    width: 150,
                    align: 'center',
                    key: 'productCode'
                },
                {
                    title: '产品名称',
                    minWidth: 260,
                    align: 'center',
                    key: 'productName',
                },
                {
                    title: '保司名称',
                    minWidth: 200,
                    align: 'center',
                    key: 'companyName'
                },
                {
                    title: '业务分类',
                    minWidth: 120,
                    align: 'center',
                    render(h, params) {
                        const themeName = params.row.themeName;
                        return <span>{themeName ? themeName : '-'}</span>;
                    }
                },
                {
                    title: '险种code',
                    width: 150,
                    align: 'center',
                    key: 'insuranceCode'
                },
                {
                    title: '险种名称',
                    minWidth: 250,
                    align: 'center',
                    key: 'insuranceName'
                },
                {
                    title: '主附险类型',
                    minWidth: 100,
                    align: 'center',
                    render(h, params) {
                        const productType = params.row.productType;
                        return <span>{productType == '1' ? '主险' : '附加险'}</span>;
                    }
                },
                {
                    title: '操作',
                    width: 120,
                    align: 'center',
                    slot: 'action',
                    fixed: 'right'
                }
            ]
        };
    },

    created() {
        this.initProductList();
        this.queryCompanyList();
        this.disabled = this.$route.query.disabled;
    },

    methods: {
        // 查询所属保司
        queryCompanyList() {
            this.$http({
                url: '/buz/insuranceCompany/read/list',
                type: 'POST',
                data: {
                    companyType: '1'
                }
            }).then(res => {
                this.productCompany = res.data;
            });
        },
        // 全选
        selectCheckboxIsAll(value) {
            this.selectIds = value ? this.list : [];
            this.handleTableAllSelectTree(value);
        },
        // 全选/取消全选
        handleTableAllSelectTree(value) {
            this.productList = this.productList.map(item => {
                item._checked = value;
                item._disabled = value;
                return item;
            });
        },
        getAllProductList() {
            return this.$http({
                url: '/buz/covenantProduct/read/list',
                type: 'POST',
                data: {
                    ...this.searchObj,
                    covenantId: this.covenantId,
                    pageNo: 1,
                    pageSize: 99999
                }
            });
        },
        async initProductList() {
            if (!this.covenantId) return;
            let listData = await this.getAllProductList(); //获取全部签约产品 用于勾选全部产品
            listData.data.length == 0 ? (this.checkboxIsAll = false) : '';
            this.list = listData.data;
            this.$root.$children[0].isShowLoading = true;
            this.searchObj.covenantId = this.covenantId;
            this.$http({
                url: '/buz/covenantProduct/read/list',
                type: 'POST',
                data: this.searchObj,
                apiPermissionCode:'pro_6_1'
            }).then(res => {
                this.productList = res.data.map(item => {
                    item._checked = this.checkboxIsAll;
                    item._disabled = this.checkboxIsAll;
                    return item;
                });
                this.selectIds = this.checkboxIsAll ? listData.data : [];
                this.total = res.total;
                this.$root.$children[0].isShowLoading = false;
            });
        },
        // 搜索
        search() {
            this.searchObj.pageNo = 1;
            this.initProductList();
            
        },
        // 重置
        reset() {
            this.searchObj = {
                pageNo: 1,
                pageSize: 10
            };
            this.initProductList();
        },
        // 删除
        submitDelete(item) {
            this.$notice.inquiry('确认删除操作？').then(async () => {
                this.$http({
                    url: `/buz/covenantProduct/del?id=${item.id}`,
                    type: 'GET'
                }).then(res => {
                    this.$Message.success('删除成功');
                    this.initProductList();
                });
            });
        },

        // 批量删除
        del() {
            let ids = this.selectIds.map(item => item.id);
            this.$notice.inquiry('确认删除操作？').then(async () => {
                this.$http({
                    url: `/buz/covenantProduct/batchDel`,
                    type: 'POST',
                    data: {
                        ids,
                        covenantId: this.covenantId
                    }
                })
                    .then(res => {
                        this.$Message.success('删除成功');
                    })
                    .finally(() => {
                        this.searchObj.pageNo = 1;
                        this.initProductList();
                    });
            });
        },

        // 选中某个
        selectRow(list) {
            this.selectIds = list;
        },
        // 分页
        pageChange(pageNo) {
            this.searchObj.pageNo = pageNo;
            this.initProductList();
        }
    }
};
</script>

<style lang="scss" scoped>
.btn-back {
    position: absolute;
    right: 20px;
    top: 10px;
}
.setTable {
    margin-top: 20px;
}

.disabled {
    color: #c5c8ce;
}

.disabled:hover {
    cursor: no-drop;
}
.all-select {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    span {
        margin-left: 30px;
        .select-num {
            margin-left: 0px;
            color: #236dff;
            font-weight: bold;
        }
    }
}
</style>
